/*
 * Approved copy constants for the Governance Tile · direction-of-travel chart.
 *
 * Strings are word-for-word from mockup v8.8.12 lines 1178-1187 and
 * carry [COPY-APPROVED: governance-tile-v8] (2026-07-24).  Static
 * mockup denominators ("48 task-equivalent turns", "0 → +48",
 * "0 → −48", "Denominator: 48 (this session · turns 1–48)") are
 * stripped from this manifest — every axis label and legend endpoint
 * is composed live in DirectionChart.jsx from `tasks_total` (or from
 * the endpoint field once the per-turn time series lands under
 * IJ-034 / IJ-045).  Attestation-honesty rule · anchor GB-013.
 */

export const CHART_TITLE_PREFIX = 'Direction of travel · one node per event';
export const CHART_TITLE_ZERO_TAIL = ' · no events in this window yet';
export const CHART_TITLE_ACTIVE_TAIL_SUFFIX =
  ' · newest event sits nearest zero';

export const CHART_TITLE_TOOLTIP =
  'Counting starts at zero where the axes meet. Every error, miss, or skip in the window is one node on the red line below zero. Every success (a Judge PASS) is one node on the green line above zero. The newest event sits nearest zero and older events run outward. Hover any node for a short description of what it is. Both lines climb away from zero as events accrue, so a flat red line means a clean window.';

export const CHART_EXPLAINER_STRONG =
  'How to read this chart (every node is one event · hover for its description).';
export const CHART_EXPLAINER_BODY =
  'Counting starts at zero where the axes cross. Below zero, the red line drops one node for each error, miss, or skip in this window. Above zero, the green line climbs one node for each success. The newest event sits nearest zero; older events run outward. Hover any node to read a short description of that event. The scope toggle (Session, Weekly, Monthly, Yearly) changes which events show.';

export const CHART_EMPTY_STATE_TITLE = 'No events in this window yet.';
export const CHART_EMPTY_STATE_BODY =
  'The chart draws one node per event the moment an error, miss, skip, or success lands in the selected scope window. Change the scope toggle above to widen the window.';

// Y-axis labels for the positive and negative halves.  The mockup used
// # of success tasks or catches (+) above zero and # of wrong + skipped
// (\u2212) below zero.  Retained verbatim.
export const CHART_Y_LABEL_POS = '# of success tasks or catches (+)';
export const CHART_Y_LABEL_NEG = '# of wrong + skipped (\u2212)';
export const CHART_X_LABEL = 'events \u00B7 newest nearest zero';
export const CHART_ZERO_LABEL = 'zero';

// Line series descriptors.  When per-turn arrays land on the endpoint
// each descriptor gains an `arraySelector(summary) -> number[]` so
// DirectionChart.jsx can plot them.  Today every series is empty by
// definition (the endpoint does not yet emit per-turn arrays); the
// chart renders the axis shell + the empty-state message.
export const CHART_SERIES = [
  {
    key: 'operator-catches',
    label: 'Operator catches',
    colour: '#fbbf24',
    stroke: 'solid',
    sign: 'positive',
  },
  {
    key: 'judge-wrongs',
    label: 'Judge wrongs',
    colour: '#f97316',
    stroke: 'dashed',
    sign: 'negative',
    offsetPx: 8, // drawn 8 px above the E1 wrongs line for visual separation
  },
  {
    key: 'e1-wrongs',
    label: 'E1 wrongs',
    colour: '#ef4444',
    stroke: 'solid',
    sign: 'negative',
  },
  {
    key: 'e1-successes',
    label: 'E1 successes',
    colour: '#22c55e',
    stroke: 'solid',
    sign: 'positive',
  },
  {
    key: 'judge-successes',
    label: 'Judge successes',
    colour: '#a78bfa',
    stroke: 'solid',
    sign: 'positive',
  },
];
